"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const utils_1 = require("./../utils");
var UserChoice;
(function (UserChoice) {
    UserChoice["ACCEPTED"] = "accepted";
    UserChoice["DISMISSED"] = "dismissed";
})(UserChoice || (UserChoice = {}));
;
;
;
const usePwa = () => {
    const [canInstall, setCanInstall] = react_1.useState(false);
    const [isInstalled, setInstalled] = react_1.useState(false);
    const [isOffline, setOffline] = react_1.useState(false);
    const [userChoice, setUserChoice] = react_1.useState('unknow');
    const deferredPrompt = react_1.useRef();
    const handleInstallEvent = react_1.useCallback(() => setInstalled(true), []);
    const handleBeforePromptEvent = react_1.useCallback((event) => {
        event.preventDefault();
        deferredPrompt.current = event;
        setCanInstall(true);
    }, []);
    const handleOfflineEvent = react_1.useCallback((offline) => () => {
        setOffline(offline);
    }, []);
    react_1.useEffect(() => {
        if (utils_1.isServer()) {
            return;
        }
        window.addEventListener('beforeinstallprompt', handleBeforePromptEvent);
        return () => window.removeEventListener('beforeinstallprompt', handleBeforePromptEvent);
    }, [handleBeforePromptEvent]);
    react_1.useEffect(() => {
        if (utils_1.isServer()) {
            return;
        }
        window.addEventListener('appinstalled', handleInstallEvent);
        return () => window.removeEventListener('appinstalled', handleInstallEvent);
    }, [handleInstallEvent]);
    react_1.useEffect(() => {
        if (utils_1.isServer()) {
            return;
        }
        if (navigator) {
            setOffline(!navigator.onLine);
        }
        window.addEventListener('online', handleOfflineEvent(false));
        window.addEventListener('offline', handleOfflineEvent(true));
        return () => {
            window.removeEventListener('online', handleOfflineEvent(false));
            window.removeEventListener('offline', handleOfflineEvent(true));
        };
    }, [handleOfflineEvent]);
    const installPrompt = react_1.useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        if (!deferredPrompt.current || utils_1.isServer()) {
            return;
        }
        deferredPrompt.current.prompt();
        const choiceResult = yield deferredPrompt.current.userChoice;
        deferredPrompt.current = null;
        setUserChoice(choiceResult.outcome);
    }), []);
    const isStandalone = react_1.useMemo(() => (!utils_1.isServer() && (navigator.standalone || window.matchMedia('(display-mode: standalone)').matches)), []);
    return {
        installPrompt,
        isInstalled,
        isStandalone,
        isOffline,
        canInstall,
        userChoice,
    };
};
exports.default = usePwa;
